var map = {
	"./cn.json": 2461,
	"./de.json": 2462,
	"./en.json": 2463,
	"./es.json": 2464,
	"./fr.json": 2465,
	"./gb.json": 2466,
	"./it.json": 2467,
	"./jp.json": 2468
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2460;


//////////////////
// WEBPACK FOOTER
// ./src/locales [A-Za-z0-9-_,\s]+\.json$/
// module id = 2460
// module chunks = 61